import React from 'react';
import ReactDOM from 'react-dom/client';
import { QrUpload } from 'qr-upload-sdk';
import 'qr-upload-sdk/styles.css';

import App from './App';
import i18n from './i18n/i18n';

import reportWebVitals from './reportWebVitals';
import './index.css';
import GlobalProvider from './globalContext';
import { initBrandTheme } from './theme/brands';

initBrandTheme();

// Polyfill for crypto.randomUUID() if not available
if (!window.crypto?.randomUUID) {
  if (!window.crypto) {
    (window as any).crypto = {};
  }
  (window.crypto as any).randomUUID = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };
}

// Initialize QR Upload SDK
if (!window.qrUploadSdk) {
  window.qrUploadSdk = new QrUpload();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const initI18n = i18n;
root.render(
  // <React.StrictMode>
    <GlobalProvider>
      <App />
    </GlobalProvider>
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
